export const TEST_ID = 'searchIcon';
